// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "price__popup-2JJJY";
var _4 = "close-19_i9";
export { _1 as "__esModule", _2 as "mobile", _3 as "price__popup", _4 as "close" }
export default { "__esModule": _1, "mobile": _2, "price__popup": _3, "close": _4 }
